<div
    class="tw-pt-0 md:tw-pt-[32px] xl:tw-px-[45px] tw-mx-0 md:tw-mx-[70px] xl:tw-mx-0"
    (click)="closeDropdown()"
>
    <!-- Desktop View -->
    <div class="tw-hidden lg:tw-flex tw-gap-9 tw-mb-5">
        <div
            *ngFor="let dt of fieldInfo"
            class="tw-border tw-border-[#1166EE] tw-rounded-xl tw-w-[30%] tw-text-[12px] tw-leading-[14px] tw-text-[#5F5F5F]"
        >
            <div class="tw-flex tw-items-start tw-p-4">
                <div
                    class="tw-w-[40px] tw-h-[40px] tw-flex tw-justify-center tw-mr-3 tw-border tw-border-[#1166EE] tw-rounded-full"
                >
                    <img
                        [src]="dt.imgUrl"
                        alt="info"
                        class="tw-w-full tw-h-full object-cover tw-p-[6px]"
                    />
                </div>
                <div class="tw-flex-1">
                    <div class="tw-font-bold tw-pb-1">
                        {{ dt.que | translate }}
                    </div>
                    <div class="tw-font-medium">{{ dt.ans | translate }}</div>
                </div>
            </div>
        </div>
    </div>

    <!-- Mobile Dialog -->
    <div class="tw-block lg:tw-hidden">
        <div
            *ngIf="isModalOpen"
            class="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-z-10 tw-flex tw-items-center tw-justify-center"
        >
            <div
                class="tw-bg-white tw-rounded-xl tw-w-[90%] tw-max-w-md tw-px-5 tw-pb-5"
            >
                <div class="tw-flex tw-justify-end tw-mb-2">
                    <button
                        (click)="isModalOpen = false"
                        class="tw-text-[#1166EE] tw-text-[25px]"
                    >
                        &times;
                    </button>
                </div>
                <div class="tw-space-y-4">
                    <div
                        *ngFor="let dt of fieldInfo"
                        class="tw-border tw-border-[#1166EE] tw-rounded-xl tw-p-4 tw-text-[12px] tw-leading-[14px] tw-text-[#5F5F5F]"
                    >
                        <div class="tw-flex tw-items-start">
                            <div
                                class="tw-w-10 tw-h-10 tw-flex tw-justify-center tw-mr-3 tw-border tw-border-[#1166EE] tw-rounded-full"
                            >
                                <img
                                    [src]="dt.imgUrl"
                                    alt="info"
                                    class="tw-w-full tw-h-full tw-object-cover tw-p-[6px]"
                                />
                            </div>
                            <div class="tw-flex-1">
                                <div class="tw-font-bold tw-pb-1">
                                    {{ dt.que | translate }}
                                </div>
                                <div class="tw-font-medium">
                                    {{ dt.ans | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div #formContainer>
        <form
            [formGroup]="financingInfoForm"
            (ngSubmit)="onFormSubmit($event, financingInfoForm.value)"
            class="tw-flex tw-flex-col tw-gap-0 md:tw-gap-[28px]"
        >
            <div
                class="tw-grid tw-grid-cols-1 tw-grid-cols-[180px,calc(100%_-_180px)]- xl:tw-grid-cols-[623px,calc(100%_-_623px)]"
            >
                <div
                    class="tw-w-full tw-mt-[24px] md:tw-mt-0"
                    id="scrollableDiv"
                >
                    <label
                        class="tw-flex tw-text-[16px] tw-leading-[24px] tw-text-black tw-font-[500] tw-mb-[20px] md:tw-mb-0"
                        >{{ "NEW_APPLICATION.FINANCING_INFO" | translate }}
                        <span (click)="isModalOpen = true"
                            ><img
                                src="../../../../../assets/images/info-vector.png"
                                alt="info-vector"
                                class="tw-ml-3 tw-block lg:tw-hidden"
                            /> </span
                    ></label>
                    <div class="tw-grid tw-gap-[16px] tw-mb-[24px]">
                        <revamp-select-general
                            class="tw-w-full"
                            [options]="PurposeOfFinancingOptions"
                            [label]="
                                'NEW_APPLICATION.PURPOSE_OF_FINANCING'
                                    | translate
                            "
                            [placeHolder]="
                                'NEW_APPLICATION.DROPDOWN_PLACEHOLDER'
                                    | translate
                            "
                            [currentValue]="financingPurpose"
                            (selectionChange)="
                                handlePurposeOfFinancingOptions($event)
                            "
                            (dropdownToggle)="closeAllDropdowns(0)"
                            [mandatoryField]="true"
                            [controlName]="'financingPurpose'"
                            [contentUnderline]="false"
                            [headerUnderline]="false"
                            [tooltipDataHeading]="{
                                header: 'FINANCIAL_INFO_TOOLTIP.PURPOSE_TITLE',
                                content:
                                    'FINANCIAL_INFO_TOOLTIP.PURPOSE_CONTENT',
                            }"
                            [errors]="
                                getErrors(
                                    'financingPurpose',
                                    'NEW_APPLICATION.FINANCING_INFO_COMMON_ERROR'
                                        | translate
                                )
                            "
                            [isDropdownOpen]="toggleDropDown[0]"
                        />
                    </div>
                    <div class="tw-grid md:tw-grid-cols-1 tw-mb-0">
                        <revamp-input-general
                            class="tw-block tw-w-[100%] tw-mb-[24px]"
                            [mandatoryField]="true"
                            [label]="
                                'NEW_APPLICATION.PREFERRED_AMOUNT' | translate
                            "
                            [placeHolder]="'RM'"
                            [controlName]="'prefferedAmount'"
                            (input)="keyPressNumbers($event, 'isPrefAmount')"
                            (paste)="pasteNumberOnly($event)"
                            [errors]="
                                getErrors(
                                    'prefferedAmount',
                                    'ERROR.AMOUNT_ERROR' | translate
                                )
                            "
                            [maxlength]="maxPreferredAmount"
                        />
                        <revamp-select-general
                            *ngIf="!isDGP"
                            class="tw-w-full tw-mb-[24px]"
                            [options]="tenureOptions"
                            [label]="
                                'NEW_APPLICATION.PREFERRED_INSTALLMENT_YEAR'
                                    | translate
                            "
                            [placeHolder]="
                                'NEW_APPLICATION.DROPDOWN_PLACEHOLDER'
                                    | translate
                            "
                            [currentValue]="tenure"
                            (selectionChange)="handleTenureOption($event)"
                            (dropdownToggle)="closeAllDropdowns(1)"
                            [controlName]="'tenure'"
                            [errors]="
                                getErrors(
                                    'tenure',
                                    'NEW_APPLICATION.FINANCING_INFO_COMMON_ERROR'
                                        | translate
                                )
                            "
                            [isDropdownOpen]="toggleDropDown[1]"
                            [tooltipDataHeading]="{
                                header: 'FINANCIAL_INFO_TOOLTIP.PREFERRED_INSTALLMENT_YEAR_TITLE',
                                content:
                                    'FINANCIAL_INFO_TOOLTIP.PREFERRED_INSTALLMENT_YEAR_CONTENT',
                            }"
                            [mandatoryField]="true"
                            [monthYear]="monthYear"
                            (monthClick)="handleMonthClick()"
                            (yearClick)="handleYearClick()"
                            [showPipe]="true"
                        />
                    </div>
                    <div
                        class="tw-grid tw-gap-[28px] md:tw-grid-cols-1 tw-mb-0"
                    >
                        <revamp-select-general
                            class="tw-w-full"
                            [options]="businessTypeOptions"
                            [label]="
                                'NEW_APPLICATION.BUSINESS_TYPE' | translate
                            "
                            [placeHolder]="
                                'NEW_APPLICATION.DROPDOWN_PLACEHOLDER'
                                    | translate
                            "
                            [currentValue]="businessType"
                            (selectionChange)="
                                handleBusinessTypeOptions($event)
                            "
                            (dropdownToggle)="closeAllDropdowns(2)"
                            [mandatoryField]="true"
                            [controlName]="'businessType'"
                            [errors]="
                                getErrors(
                                    'businessType',
                                    'NEW_APPLICATION.FINANCING_INFO_COMMON_ERROR'
                                        | translate
                                )
                            "
                            [isDropdownOpen]="toggleDropDown[2]"
                        />
                        <revamp-select-general
                            class="tw-w-full tw-mb-[24px]"
                            [options]="yesNoOptions"
                            [label]="'REG_IN_SABAH_SARAWAK' | translate"
                            [placeHolder]="
                                'NEW_APPLICATION.DROPDOWN_PLACEHOLDER'
                                    | translate
                            "
                            [currentValue]="yesNoOptionType"
                            (selectionChange)="onSelectSabahSarwak($event)"
                            (dropdownToggle)="closeAllDropdowns(3)"
                            [mandatoryField]="true"
                            [controlName]="'sabahSarwak'"
                            [errors]="
                                getErrors(
                                    'sabahSarwak',
                                    'NEW_APPLICATION.FINANCING_INFO_COMMON_ERROR'
                                        | translate
                                )
                            "
                            [isDropdownOpen]="toggleDropDown[3]"
                        />
                    </div>

                    <div
                        *ngIf="showCompanyRegNo"
                        class="tw-relative tw-grid tw-gap-[16px] md:tw-gap-[32px] md:tw-grid-cols-1 tw-mb-[24px]"
                    >
                        <revamp-input-general
                            class="tw-block tw-w-full"
                            [mandatoryField]="true"
                            [label]="
                                'NEW_APPLICATION.COMPANY_REG_NUMBER' | translate
                            "
                            [placeHolder]="
                                'NEW_APPLICATION.TYPE_HERE' | translate
                            "
                            [controlName]="'companyRegNo'"
                            [verifyButton]="showVerifyCompanyRegNoBtn"
                            [verifyCompanyRegNoLoading]="
                                companyRegNoVerifyLoading
                            "
                            [buttonVerified]="showBRNVerified"
                            [tooltipDataHeading]="true"
                            [TooltipData]="{
                                header: 'REMINDER',
                                content:
                                    'BUSINESS_NUMB_CANT_CHANGE_ONCE_VERIFIED',
                            }"
                            (isCompanyRegNoVerified)="
                                onVerifyCompanyRegNo($event)
                            "
                            [disableCompanyRegVerifyBtn]="
                                companyRegNoVerifyLoading
                            "
                            [maxlength]="maxCompanyRegNo"
                            [backgroundOverride]="
                                disableCompanyRegNo ? '!tw-bg-[#e9e9e9]' : ''
                            "
                            [errors]="
                                getErrors(
                                    'companyRegNo',
                                    'ERROR.COMPANY_REG_NUMBER' | translate
                                )
                            "
                        />
                        <div
                            class="tw-hidden tw-min-h-[127px] md:tw-min-h-[unset] tw-rounded-[16px] tw-bg-white tw-absolute tw-top-[-140px] md:tw-top-[-25px] tw-left-0 tw-right-0 md:tw-left-[calc(50%_+_16px)] tw-z-[99] md:tw-max-w-[275px] tw-w-full tw-border tw-border-solid tw-border-caption-grary/0.15"
                        >
                            <span
                                class="tw-text-[18px] tw-leading-[20px] tw-font-[600] tw-block tw-py-[15px] tw-px-[20px] tw-pr-[10px] tw-border-b tw-border-solid tw-border-caption-grary/0.15"
                                >{{ "NEW_OLD_ACCEPTABLE" | translate }}</span
                            >
                            <div class="tw-relative">
                                <p
                                    class="tw-text-[16px] tw-leading-[24px] tw-font-[500] tw-text-caption-gray !tw-m-0 tw-pt-[10px] tw-pb-[16px] tw-pr-[5px] tw-pl-[20px]"
                                >
                                    {{
                                        "NEW_APPLICATION.NEW_OLD_COMPANY_REG_ACCEPTABLE"
                                            | translate
                                    }}
                                </p>
                                <div
                                    class="tw-bottom-[-32px] md:tw-top-[3px] tw-right-[40px] md:tw-left-[-9px] tw-absolute tw-w-[16px] tw-h-[16px] tw-rotate-[-45deg] md:tw-rotate-[45deg] tw-bg-white tw-border-l tw-border-b tw-boder-solid tw-border-caption-gray/0.15"
                                ></div>
                            </div>
                        </div>
                    </div>

                    <!-- no need to show separate old/new biz reg no., show only new biz reg no. -->
                    <!-- show oldBizRegNo -->
                    <!-- <div
                        *ngIf="showCompanyRegNo && showOldBizRegNo"
                        class="tw-relative tw-grid tw-gap-[16px] md:tw-gap-[32px] md:tw-grid-cols-1 tw-mb-[24px]"
                    >
                        <revamp-input-general
                            class="tw-block tw-w-full"
                            [mandatoryField]="true"
                            [label]="
                                'NEW_APPLICATION.OLD_COMPANY_REG_NUMBER'
                                    | translate
                            "
                            [placeHolder]="
                                'NEW_APPLICATION.TYPE_HERE' | translate
                            "
                            [controlName]="'oldCompanyRegNo'"
                            [verifyButton]="showVerifyCompanyRegNoBtn"
                            [verifyCompanyRegNoLoading]="
                                companyRegNoVerifyLoading
                            "
                            [buttonVerified]="showBRNVerified"
                            [tooltipDataHeading]="true"
                            [TooltipData]="{
                                header: 'REMINDER',
                                content:
                                    'BUSINESS_NUMB_CANT_CHANGE_ONCE_VERIFIED',
                            }"
                            (isCompanyRegNoVerified)="
                                onVerifyCompanyRegNo($event)
                            "
                            [disableCompanyRegVerifyBtn]="
                                companyRegNoVerifyLoading
                            "
                            [backgroundOverride]="
                                disableCompanyRegNo ? '!tw-bg-[#e9e9e9]' : ''
                            "
                        />
                        <div
                            class="tw-hidden tw-min-h-[127px] md:tw-min-h-[unset] tw-rounded-[16px] tw-bg-white tw-absolute tw-top-[-140px] md:tw-top-[-25px] tw-left-0 tw-right-0 md:tw-left-[calc(50%_+_16px)] tw-z-[99] md:tw-max-w-[275px] tw-w-full tw-border tw-border-solid tw-border-caption-grary/0.15"
                        >
                            <span
                                class="tw-text-[18px] tw-leading-[20px] tw-font-[600] tw-block tw-py-[15px] tw-px-[20px] tw-pr-[10px] tw-border-b tw-border-solid tw-border-caption-grary/0.15"
                                >{{ "NEW_OLD_ACCEPTABLE" | translate }}</span
                            >
                            <div class="tw-relative">
                                <p
                                    class="tw-text-[16px] tw-leading-[24px] tw-font-[500] tw-text-caption-gray !tw-m-0 tw-pt-[10px] tw-pb-[16px] tw-pr-[5px] tw-pl-[20px]"
                                >
                                    {{
                                        "NEW_APPLICATION.NEW_OLD_COMPANY_REG_ACCEPTABLE"
                                            | translate
                                    }}
                                </p>
                                <div
                                    class="tw-bottom-[-32px] md:tw-top-[3px] tw-right-[40px] md:tw-left-[-9px] tw-absolute tw-w-[16px] tw-h-[16px] tw-rotate-[-45deg] md:tw-rotate-[45deg] tw-bg-white tw-border-l tw-border-b tw-boder-solid tw-border-caption-gray/0.15"
                                ></div>
                            </div>
                        </div>
                    </div> -->

                    <!-- Refresh Button -->
                    <div
                        class="tw-flex md:tw-pr-[24px] tw-mb-[20px]"
                        *ngIf="showBRNVerified"
                    >
                        <div
                            class="tw-flex tw-items-start tw-text-black/[0.40] tw-text-[14px]"
                        >
                            <mat-icon class="tw-text-[20px] tw-w-[20px]"
                                >error_outline</mat-icon
                            >
                            <span class="tw-flex-1">
                                {{ "NEW_APPLICATION.REFRESH_INFO" | translate }}
                            </span>
                        </div>

                        <button
                            [ngClass]="
                                isRefresh ? 'disabledButton' : 'purpleButton'
                            "
                            [disabled]="isRefresh"
                            (click)="onRefreshClick()"
                            class="smallButton tw-flex-none"
                        >
                            <span class="buttonAlignment">
                                <span>{{
                                    "NEW_APPLICATION.REFRESH" | translate
                                }}</span>
                            </span>
                        </button>
                    </div>

                    <!-- Adding List of Directors -->
                    <ng-container
                        *ngIf="showDirectorList && directorsList?.length != 0"
                    >
                        <label
                            class="tw-inline-block tw-text-[16px] tw-leading-[20px] tw-text-caption-gray tw-font-[600] tw-mb-[16px]"
                        >
                            {{ "NEW_APPLICATION.LIST_OF_OWNERS" | translate }}
                        </label>
                        <div
                            class="tw-grid tw-gap-[16px] md:tw-gap-[32px] md:tw-grid-cols-1 tw-mb-[32px]"
                        >
                            <div
                                *ngFor="
                                    let director of directorsList;
                                    let i = index
                                "
                            >
                                <div class="tw-flex tw-mb-[20px]">
                                    <div class="tw-flex tw-items-center">
                                        <input
                                            type="radio"
                                            class="tw-rounded-full tw-w-[24px] tw-h-[24px]"
                                            style="cursor: pointer"
                                            value="{{ i }}"
                                            name="director"
                                            formControlName="director"
                                            (click)="handleDirectorChange(i)"
                                            [attr.disabled]="
                                                successVerifyIdentification
                                                    ? true
                                                    : null
                                            "
                                        />
                                    </div>
                                    <div class="tw-pl-[1.5rem] tw-w-full">
                                        <span
                                            class="tw-flex tw-gap-2 tw-items-center tw-text-[12px] tw-leading-[18px] tw-font-[500] tw-text-gray-400"
                                        >
                                            {{
                                                "NEW_APPLICATION.DIRECTOR"
                                                    | translate
                                            }}
                                        </span>
                                        <label
                                            class="tw-w-full tw-text-[21px] tw-leading-[32px] tw-text-black tw-font-semibold"
                                            >{{ director.Name }}</label
                                        >
                                    </div>
                                </div>
                                <!-- <hr
                                    class="tw-mt-[20px] tw-mb-[-10px]"
                                    *ngIf="
                                        directorsList.length > 2 &&
                                        i + 1 !== directorsList.length
                                    "
                                /> -->
                                <mat-divider
                                    class="dividerDirector"
                                ></mat-divider>
                            </div>
                        </div>
                    </ng-container>

                    <!-- Adding List of Owners -->
                    <ng-container
                        *ngIf="showOwnersList && ownersList?.length != 0"
                    >
                        <label
                            class="tw-inline-block tw-text-[16px] tw-leading-[20px] tw-text-caption-gray tw-font-[600] tw-mb-[16px]"
                        >
                            {{ "NEW_APPLICATION.LIST_OF_OWNERS" | translate }}
                        </label>
                        <div
                            class="tw-grid tw-gap-[16px] md:tw-gap-[32px] md:tw-grid-cols-1 tw-mb-[32px]"
                        >
                            <div
                                *ngFor="let owner of ownersList; let i = index"
                            >
                                <div class="tw-flex tw-mb-[20px]">
                                    <div class="tw-flex tw-items-center">
                                        <input
                                            type="radio"
                                            class="tw-rounded-full tw-w-[24px] tw-h-[24px]"
                                            style="cursor: pointer"
                                            value="{{ i }}"
                                            name="owner"
                                            formControlName="owner"
                                            (click)="handleOwnerChange(i)"
                                            [attr.disabled]="
                                                successVerifyIdentification
                                                    ? true
                                                    : null
                                            "
                                        />
                                    </div>
                                    <div class="tw-pl-[1.5rem] tw-w-full">
                                        <label
                                            class="tw-w-full tw-text-[21px] tw-leading-[32px] tw-text-black tw-font-semibold"
                                            >{{ owner.Name }}</label
                                        >
                                    </div>
                                </div>
                                <!-- <hr
                                    class="tw-mt-[20px] tw-mb-[-10px]"
                                    *ngIf="
                                        ownersList.length > 2 &&
                                        i + 1 !== ownersList.length
                                    "
                                /> -->
                                <mat-divider
                                    class="dividerDirector"
                                ></mat-divider>
                            </div>
                        </div>
                    </ng-container>

                    <!-- Adding List of Interested Parties -->
                    <ng-container
                        *ngIf="showPartiesList && partiesList?.length != 0"
                    >
                        <label
                            class="tw-inline-block tw-text-[16px] tw-leading-[20px] tw-text-caption-gray tw-font-[600] tw-mb-[16px]"
                        >
                            {{ "NEW_APPLICATION.LIST_OF_OWNERS" | translate }}
                        </label>
                        <div
                            class="tw-grid tw-gap-[16px] md:tw-gap-[32px] md:tw-grid-cols-1 tw-mb-[32px]"
                        >
                            <div
                                *ngFor="let party of partiesList; let i = index"
                            >
                                <div class="tw-flex tw-mb-[20px]">
                                    <div class="tw-flex tw-items-center">
                                        <input
                                            type="radio"
                                            class="tw-rounded-full tw-w-[24px] tw-h-[24px]"
                                            style="cursor: pointer"
                                            value="{{ i }}"
                                            formControlName="party"
                                            name="party"
                                            (click)="handlePartyChange(i)"
                                            [attr.disabled]="
                                                successVerifyIdentification
                                                    ? true
                                                    : null
                                            "
                                        />
                                    </div>
                                    <div class="tw-pl-[1.5rem] tw-w-full">
                                        <label
                                            class="tw-w-full tw-text-[21px] tw-leading-[32px] tw-text-black tw-font-semibold"
                                            >{{ party.Name }}</label
                                        >
                                    </div>
                                </div>
                                <hr
                                    class="tw-mt-[20px] tw-mb-[-10px]"
                                    *ngIf="
                                        party.length > 2 &&
                                        i + 1 !== party.length
                                    "
                                />
                                <mat-divider
                                    class="dividerDirector"
                                ></mat-divider>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="companyName">
                        <label
                            class="tw-block tw-mb-[16px] tw-opacity-60 tw-text-black tw-text-2xl tw-font-semibold tw-leading-loose"
                            >{{ companyName }}</label
                        >
                    </ng-container>

                    <ng-container
                        *ngIf="
                            (showDirectorList && directorsList?.length != 0) ||
                            (showOwnersList && ownersList?.length != 0) ||
                            (showPartiesList && partiesList?.length != 0)
                        "
                    >
                        <label
                            class="tw-inline-block tw-text-[16px] tw-leading-[20px] tw-text-caption-gray tw-font-[600] tw-mb-[16px]"
                            >{{ "APPLICANT_DETAIL" | translate }}</label
                        >
                        <div
                            class="tw-grid tw-gap-[16px] md:tw-gap-[28px] md:tw-grid-cols-1 tw-mb-[16px] md:tw-mb-0"
                        >
                            <div>
                                <revamp-input-general
                                    class="tw-block tw-w-[100%]"
                                    [mandatoryField]="true"
                                    [tooltipDataHeading]="true"
                                    [TooltipData]="{
                                        header: 'PLEASE_VERIFY',
                                        content: 'PLEASE_VERIFY_MSG',
                                    }"
                                    [label]="
                                        'IDENTIFICATION_NUMBER' | translate
                                    "
                                    [placeHolder]="
                                        'NEW_APPLICATION.TYPE_HERE' | translate
                                    "
                                    [controlName]="'identificationNo'"
                                    [verifyIdentificationNoBtn]="
                                        showVerifyIdentificationNoBtn
                                    "
                                    [identificationNoButtonVerified]="
                                        showKYCVerified
                                    "
                                    (isIdentificationNoVerified)="
                                        onVerfiyIdentificationNo(
                                            $event,
                                            showDirectorList,
                                            showOwnersList,
                                            showPartiesList
                                        )
                                    "
                                    [verifyIdentificationNoLoading]="
                                        identificationNoLoading
                                    "
                                    [disableIdentificationVerifyBtn]="
                                        identificationNoLoading
                                    "
                                    formControlName="director"
                                    (input)="
                                        keyPressNumbers(
                                            $event,
                                            'noPrefAmount',
                                            'isIdentificationNo'
                                        )
                                    "
                                    (paste)="pasteNumberOnly($event)"
                                    [backgroundOverride]="
                                        disableIdentificationNo
                                            ? '!tw-bg-[#e9e9e9]'
                                            : ''
                                    "
                                    [maxlength]="maxIdentificationNo"
                                    [errors]="
                                        getErrors(
                                            'identificationNo',
                                            'ERROR.IDENTIFICATION_NUMBER'
                                                | translate
                                        )
                                    "
                                />
                            </div>
                        </div>
                        <div
                            class="tw-mt-1 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black tw-mb-[32px]"
                        ></div>
                    </ng-container>

                    <!-- Show Identification No and Name based on Sabah Sarawak (excluding SDNBHD)-->
                    <div
                        class="tw-grid tw-gap-[16px] md:tw-gap-[28px] md:tw-grid-cols-1 tw-mb-[24px]"
                        *ngIf="showIndividualNRICName || showIndividualNRICNo"
                    >
                        <revamp-input-general
                            *ngIf="showIndividualNRICName"
                            class="tw-block tw-w-[100%]"
                            [mandatoryField]="true"
                            [label]="
                                'NEW_APPLICATION.INDIVIDUAL_NRIC_NAME'
                                    | translate
                            "
                            [placeHolder]="
                                'NEW_APPLICATION.TYPE_HERE' | translate
                            "
                            [controlName]="'individualNRICName'"
                            [maxlength]="maxIndividualNRICName"
                            (input)="restrictNumbers($event)"
                            (paste)="restrictNumbersOnPaste($event)"
                            [tooltipDataHeading]="true"
                            [TooltipData]="{
                                header: 'NEW_APPLICATION.INDIVIDUAL_NRIC_NAME',
                                content: 'ERROR.INDIVIDUAL_NRIC_NAME',
                            }"
                            [errors]="
                                getErrors(
                                    'individualNRICName',
                                    'ERROR.INDIVIDUAL_NRIC_NAME' | translate
                                )
                            "
                        />
                        <revamp-input-general
                            *ngIf="showIndividualNRICNo"
                            class="tw-w-full"
                            [mandatoryField]="true"
                            [label]="
                                'NEW_APPLICATION.INDIVIDUAL_NRIC_NO' | translate
                            "
                            [placeHolder]="
                                'NEW_APPLICATION.TYPE_HERE' | translate
                            "
                            [controlName]="'individualNRICNo'"
                            [maxlength]="maxIndividualIdNo"
                            (input)="keyPressNumbers($event)"
                            (paste)="pasteNumberOnly($event)"
                            [tooltipDataHeading]="true"
                            [TooltipData]="{
                                header: 'NRIC_NO',
                                content: 'ERROR.NRIC_POPUP_1',
                            }"
                            [errors]="
                                getErrors(
                                    'individualNRICNo',
                                    'ERROR.INDIVIDUAL_NRIC_NO' | translate
                                )
                            "
                        />
                    </div>
                    <!-- Show Identification No and Name based on Sabah Sarawak (excluding SDNBHD) fields ends -->

                    <!-- Show Company Name and Management Info based on Sabah Sarawak (excluding SDNBHD)-->
                    <div
                        class="tw-grid tw-gap-[28px] md:tw-grid-cols-1 tw-mb-[24px]"
                        *ngIf="showCompanyNRICName || showMgtNRICName"
                    >
                        <revamp-input-general
                            *ngIf="showCompanyNRICName"
                            class="tw-block tw-w-[100%]"
                            [mandatoryField]="true"
                            [label]="
                                'NEW_APPLICATION.COMPANY_NRIC_NAME' | translate
                            "
                            [placeHolder]="
                                'NEW_APPLICATION.TYPE_HERE' | translate
                            "
                            [controlName]="'companyNRICName'"
                            [maxlength]="maxCompanyNRICName"
                            (input)="onEnterCompanyNRICName($event)"
                            [errors]="getErrors('companyNRICName')"
                        />
                        <revamp-input-general
                            *ngIf="showMgtNRICName"
                            class="tw-block tw-w-[100%]"
                            [mandatoryField]="true"
                            [label]="
                                'NEW_APPLICATION.MGT_NRIC_NAME' | translate
                            "
                            [placeHolder]="
                                'NEW_APPLICATION.TYPE_HERE' | translate
                            "
                            [controlName]="'mgtNRICName'"
                            [backgroundOverride]="
                                !disableApplicantName ? '' : '!tw-bg-[#e9e9e9]'
                            "
                            [applyDisableText]="disableApplicantName"
                            [maxlength]="maxMgtNRICName"
                            (input)="restrictNumbers($event)"
                            (paste)="restrictNumbersOnPaste($event)"
                            [errors]="getErrors('mgtNRICName')"
                        />
                    </div>
                    <!-- Show Company Name and Management Info based on Sabah Sarawak (excluding SDNBHD) fields ends-->

                    <!-- business address starts -->
                    <div
                        class="tw-grid tw-gap-[28px] md:tw-grid-cols-1 tw-mb-0"
                    >
                        <revamp-input-general
                            class="tw-block tw-w-[100%]"
                            [mandatoryField]="true"
                            [label]="
                                'NEW_APPLICATION.BUSINESS_ADDRESS_1' | translate
                            "
                            [placeHolder]="
                                'NEW_APPLICATION.TYPE_HERE' | translate
                            "
                            [controlName]="'businessAddress1'"
                            [maxlength]="maxBusinessAddress1"
                            [errors]="getErrors('businessAddress1')"
                        />
                        <revamp-input-general
                            class="tw-block tw-w-[100%] tw-mb-[24px]"
                            [label]="
                                'NEW_APPLICATION.BUSINESS_ADDRESS_2' | translate
                            "
                            [placeHolder]="
                                'NEW_APPLICATION.TYPE_HERE' | translate
                            "
                            [controlName]="'businessAddress2'"
                            [maxlength]="maxBusinessAddress2"
                        />
                    </div>

                    <div
                        class="tw-grid tw-gap-[28px] md:tw-grid-cols-1 tw-mb-[24px]"
                    >
                        <revamp-select-general
                            class="tw-block tw-w-[100%]"
                            [label]="'NEW_APPLICATION.STATE' | translate"
                            [placeHolder]="
                                'NEW_APPLICATION.DROPDOWN_PLACEHOLDER'
                                    | translate
                            "
                            [options]="stateOptions"
                            [currentValue]="stateName"
                            (selectionChange)="onSelectState($event)"
                            (dropdownToggle)="closeAllDropdowns(5)"
                            [mandatoryField]="true"
                            [controlName]="'state'"
                            [errors]="
                                getErrors(
                                    'state',
                                    'NEW_APPLICATION.FINANCING_INFO_COMMON_ERROR'
                                        | translate
                                )
                            "
                            [isDropdownOpen]="toggleDropDown[5]"
                        />
                    </div>

                    <div
                        class="tw-grid tw-gap-[28px] md:tw-grid-cols-1"
                        [ngClass]="showCities ? 'tw-mb-[24px]' : ''"
                    >
                        <revamp-select-general
                            *ngIf="showCities"
                            class="tw-block tw-w-[100%]"
                            [label]="'NEW_APPLICATION.CITY' | translate"
                            [placeHolder]="
                                'NEW_APPLICATION.DROPDOWN_PLACEHOLDER'
                                    | translate
                            "
                            [options]="cityOptions"
                            [currentValue]="cityName"
                            (selectionChange)="onSelectCity($event)"
                            (dropdownToggle)="closeAllDropdowns(6)"
                            [mandatoryField]="true"
                            [controlName]="'city'"
                            [errors]="
                                getErrors(
                                    'city',
                                    'NEW_APPLICATION.FINANCING_INFO_COMMON_ERROR'
                                        | translate
                                )
                            "
                            [isDropdownOpen]="toggleDropDown[6]"
                        />
                    </div>

                    <div
                        class="tw-grid tw-gap-[16px] md:tw-gap-[28px] md:tw-grid-cols-1 tw-mb-[24px]"
                    >
                        <revamp-input-general
                            class="tw-block tw-w-[100%]"
                            [mandatoryField]="true"
                            [label]="'NEW_APPLICATION.POST_CODE' | translate"
                            [placeHolder]="
                                'NEW_APPLICATION.TYPE_HERE' | translate
                            "
                            [controlName]="'postCode'"
                            [maxlength]="maxPostCode"
                            (input)="keyPressNumbers($event)"
                            (paste)="pasteNumberOnly($event)"
                            [errors]="getErrors('postCode')"
                        />
                    </div>
                    <!-- business address ends -->

                    <div class="tw-grid tw-gap-[28px] md:tw-grid-cols-1">
                        <revamp-select-general
                            class="tw-block tw-w-[100%]"
                            [options]="yesNoOptions"
                            [label]="'BUMIPUTERA_STATUS' | translate"
                            [placeHolder]="
                                'NEW_APPLICATION.DROPDOWN_PLACEHOLDER'
                                    | translate
                            "
                            [currentValue]="bumiputeraType"
                            (selectionChange)="onSelectBumiputera($event)"
                            (dropdownToggle)="closeAllDropdowns(4)"
                            [mandatoryField]="true"
                            [controlName]="'bumiputeraStatus'"
                            [errors]="
                                getErrors(
                                    'bumiputeraStatus',
                                    'NEW_APPLICATION.FINANCING_INFO_COMMON_ERROR'
                                        | translate
                                )
                            "
                            [isDropdownOpen]="toggleDropDown[4]"
                        />
                        <!-- <div> -->
                        <revamp-input-general
                            class="tw-block tw-w-[100%]"
                            [mandatoryField]="true"
                            [label]="'AGE_OF_DIRECTOR' | translate"
                            [placeHolder]="
                                'NEW_APPLICATION.TYPE_HERE' | translate
                            "
                            [controlName]="'age'"
                            [maxlength]="maxAge"
                            (input)="keyPressNumbers($event, 'age')"
                            (paste)="pasteNumberOnly($event)"
                            [errors]="getErrors('age', 'ERROR.AGE' | translate)"
                        />
                    </div>
                </div>
                <div
                    class="tw-ml-[80px] tw-mt-[10px] tw-hidden xl:tw-block"
                    id="fixedDiv"
                >
                    <div
                        class="tw-bg-[#ffffff] borderCss tw-rounded-[24px] tw-py-[28px] tw-px-[40px] tw-flex tw-flex-col tw-gap-[10px] tw-relative tw-top-0 tw-w-[406px]"
                        id="innerFixedDiv"
                    >
                        <div
                            *ngFor="let i of rightSide; let index = index"
                            class="tw-flex tw-flex-col tw-gap-[14px]"
                        >
                            <img
                                *ngIf="index == 0"
                                class="tw-w-[45px] tw-h-[45px]"
                                src="/assets/images/preliminary.png"
                                alt="preliminary"
                            />
                            <img
                                *ngIf="index == 1"
                                class="tw-w-[45px] tw-h-[45px]"
                                src="/assets/images/expand_circle_right.png"
                                alt="expand_circle_right"
                            />
                            <img
                                *ngIf="index == 2"
                                class="tw-w-[45px] tw-h-[45px]"
                                src="/assets/images/done.png"
                                alt="done"
                            />
                            <div
                                class="tw-font-semibold tw-leadng-[21.6px] tw-text-[18px]"
                            >
                                {{ i.title | translate }}
                            </div>
                            <div
                                class="tw-font-medium tw-leading-[24px] tw-text-[16px] tw-mb-[14px]"
                            >
                                {{ i.subtitle | translate }}
                            </div>
                            <mat-divider
                                *ngIf="index < 2"
                                style="margin-bottom: 10px"
                            ></mat-divider>
                        </div>
                    </div>
                </div>
            </div>

            <mat-divider class="dividerDirector"></mat-divider>
            <div
                class="tw-hidden md:tw-flex tw-flex-wrap md:tw-flex-row md:tw-justify-end tw-gap-[10px] tw-items-center md:tw-rounded-[80px] tw-py-0 tw-px-0 md:tw-px-[15px] lg:tw-px-[27px]"
            >
                <div
                    class="tw-order-3 md:tw-order-2 tw-flex-[0_0_calc(50%_-_5px)] md:tw-flex-[0_0_180px]"
                >
                    <button
                        [attr.ga-event-id]="
                            prodCode
                                ? prodCode +
                                  '_save_as_draft_button_financial_information_click'
                                : 'save_as_draft_button_financial_information_click'
                        "
                        ga-event-category="Financial Information Page Button"
                        [attr.ga-event-label]="
                            prodCode
                                ? prodCode + ' Save As Draft Main Button Click'
                                : 'Save As Draft Main Button Click'
                        "
                        ga-track="track"
                        class="tw-text-caption-gray md:tw-max-w-[175px] tw-w-full tw-text-center"
                        type="submit"
                        name="draft"
                    >
                        {{ "SAVE_AS_DRAFT" | translate }}
                    </button>
                </div>
                <div
                    class="tw-order-1 md:tw-order-last tw-flex-[0_0_calc(50%_-_5px)] md:tw-flex-[0_0_180px] tw-mb-[10px] md:tw-mb-0"
                >
                    <button
                        [attr.ga-event-id]="
                            prodCode
                                ? prodCode +
                                  '_next_step_application_button_finp_click'
                                : 'next_step_application_button_finp_click'
                        "
                        ga-event-category="Financial Information Page Button"
                        [attr.ga-event-label]="
                            prodCode
                                ? prodCode +
                                  ' Next Step Application Button Click'
                                : 'Next Step Application Button Click'
                        "
                        ga-track="track"
                        [disabled]="disableSubmitBtn"
                        class="tw-text-[18px] tw-leading-[20px] md:tw-max-w-[175px] tw-w-full tw-text-center tw-font-[600] tw-rounded-[32px] tw-text-white tw-py-[22px] tw-px-[15px]"
                        [ngClass]="
                            financingInfoForm?.invalid || disableSubmitBtn
                                ? 'tw-bg-slate-300'
                                : 'tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300'
                        "
                        type="submit"
                        name="next"
                    >
                        {{ "NEXT" | translate }}
                    </button>
                </div>
            </div>
            <div
                class="tw-flex md:tw-hidden tw-flex-col tw-gap-[10px] tw-items-center tw-py-2 tw-px-0"
            >
                <button
                    [attr.ga-event-id]="
                        prodCode
                            ? prodCode +
                              '_next_step_application_button_finp_click'
                            : 'next_step_application_button_finp_click'
                    "
                    ga-event-category="Financial Information Page Button"
                    [attr.ga-event-label]="
                        prodCode
                            ? prodCode + ' Next Step Application Button Click'
                            : 'Next Step Application Button Click'
                    "
                    ga-track="track"
                    [disabled]="disableSubmitBtn"
                    class="tw-text-[18px] tw-leading-[20px] md:tw-max-w-[175px] tw-w-full tw-text-center tw-font-[600] tw-rounded-[32px] tw-text-white tw-py-[22px] tw-px-[15px]"
                    [ngClass]="
                        financingInfoForm?.invalid || disableSubmitBtn
                            ? 'tw-bg-slate-300'
                            : 'tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300'
                    "
                    type="submit"
                    name="next"
                >
                    {{ "NEXT" | translate }}
                </button>
                <button
                    [attr.ga-event-id]="
                        prodCode
                            ? prodCode +
                              '_save_as_draft_button_financial_information_click'
                            : 'save_as_draft_button_financial_information_click'
                    "
                    ga-event-category="Financial Information Page Button"
                    [attr.ga-event-label]="
                        prodCode
                            ? prodCode + ' Save As Draft Main Button Click'
                            : 'Save As Draft Main Button Click'
                    "
                    ga-track="track"
                    class="tw-text-caption-gray md:tw-max-w-[175px] tw-w-full tw-text-center tw-mt-[5%]"
                    type="submit"
                    name="draft"
                >
                    {{ "SAVE_AS_DRAFT" | translate }}
                </button>
            </div>
        </form>
    </div>
</div>
<app-loader [showLoader]="isRefreshLoading"></app-loader>
